import {
  createUserWithEmailAndPassword,
  sendSignInLinkToEmail,
  signInWithEmailAndPassword,
  signInWithEmailLink,
  sendPasswordResetEmail,
  verifyPasswordResetCode,
  confirmPasswordReset,
} from "firebase/auth";
import { auth } from "./firebase";

export const doCreateUserWithEmailAndPassword = async (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const doSignInWithEmailAndPassword = async (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const doSignInWithEmailLink = async (email, link) => {
  return signInWithEmailLink(auth, email, link);
};

const actionCodeSettings = {
  url: "http://localhost:3000/",

  handleCodeInApp: true,

  //linkDomain: "http://localhost:3000/",
};

export const doSendSignInLinkToEmail = (email) => {
  return sendSignInLinkToEmail(auth, email, actionCodeSettings);
};

export const doSendPasswordResetEmail = (email) => {
  // Firebase password reset emails need to be configured in Firebase Console
  // The email will contain a link that redirects to the "Continue URL" set in the Firebase Console
  return sendPasswordResetEmail(auth, email)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("✗ Password reset email failed:", error);
      console.error("Error code:", error.code);
      console.error("Error message:", error.message);
      throw error;
    });
};

export const doVerifyPasswordResetCode = (code) => {
  return verifyPasswordResetCode(auth, code);
};

export const doConfirmPasswordReset = (code, newPassword) => {
  return confirmPasswordReset(auth, code, newPassword);
};

export const doSignOut = () => {
  return auth.signOut();
};
